import { useTheme } from "@material-ui/core";
import React from "react";
import {
	AutocompleteInput,
	Filter as RaFilter,
	ReferenceInput,
	SelectInput,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import { useFiltersStyles } from "../components/lists/useStyles";
import statuses from "./statuses";
import types from "./types";

const Filters = (props) => {
	const theme = useTheme();
	const classes = useFiltersStyles();
	return (
		<RaFilter {...props} classes={classes} variant="outlined">
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn
				style={{ marginTop: theme.spacing(4) }}
				fullWidth
				{...bookmakersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<SelectInput
				allowEmpty
				emptyText="ra.action.all"
				source="type"
				choices={types}
				alwaysOn
				fullWidth
			/>
			<SelectInput
				allowEmpty
				emptyText="ra.action.all"
				source="status"
				choices={statuses}
				alwaysOn
				fullWidth
			/>
			<SelectInput
				allowEmpty
				emptyText="ra.action.all"
				source="is_manually"
				choices={[
					{ id: true, name: "ra.action.yes" },
					{ id: false, name: "ra.action.no" },
				]}
				alwaysOn
				fullWidth
				style={{ minWidth: 205 }}
			/>
		</RaFilter>
	);
};
export default Filters;
